import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import apiCustom from "../../utils/ApiCustom";
import { toast } from "react-toastify";

export const fetchPartners = createAsyncThunk(
  "partners/fetchPartners",
  async () => {
    const response = await apiCustom.get("/company-approved");
    return response.data?.data?.data?.users;
  }
);
export const createPartner = createAsyncThunk(
  "partners/createPartner",
  async (newPost, { rejectWithValue }) => {
    try {
      const response = await apiCustom.post("/company-create", newPost);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const updatePartner = createAsyncThunk(
  "partners/updatePartner",
  async ({ id, newPost }, { rejectWithValue }) => {
    try {
      // const formData = new FormData();
      // for (const key in newPost) {
      //   if (key === "image" && newPost[key] instanceof File) {
      //     formData.append("image", newPost[key]);
      //   } else if (key === "businessFieldIds" || key === "userMemberData") {
      //     formData.append(key, JSON.stringify(newPost[key]));
      //   } else {
      //     formData.append(key, newPost[key]);
      //   }
      // }

      const response = await apiCustom.put(
        `/company-update-by-id/${id}`,
        newPost
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Đã xảy ra lỗi!");
    }
  }
);

export const deletePartner = createAsyncThunk(
  "partners/deletePartner",
  async (id, { rejectWithValue }) => {
    try {
      const response = await apiCustom.delete(`/company-delete/${id}`);
      return { response };
    } catch (error) {
      return rejectWithValue(error.response?.data || "Đã xảy ra lỗi!");
    }
  }
);
export const approvePartner = createAsyncThunk(
  "partners/approvePartner",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await apiCustom.put(`/users/${id}/approve`, data, {
        headers: { "Content-Type": "application/json" },
      });
      return true;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Đã xảy ra lỗi!");
    }
  }
);
export const showPartnerByUserId = createAsyncThunk(
  "partners/showPartnerByUserId",
  async (id, { rejectWithValue }) => {
    try {
      const response = await apiCustom.get(
        `/company-show-by-user-id?userId=${id}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Đã xảy ra lỗi!");
    }
  }
);

const partnersSlice = createSlice({
  name: "partners",
  initialState: {
    partners: [],
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPartners.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchPartners.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.partners = action.payload;
      })
      .addCase(fetchPartners.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(createPartner.fulfilled, (state) => {
        // state.status = "idle";
      })
      .addCase(deletePartner.fulfilled, (state) => {
        state.status = "idle";
      })
      .addCase(updatePartner.fulfilled, (state) => {
        // state.status = "idle";
      })
      .addCase(approvePartner.fulfilled, (state) => {
        state.status = "idle";
      })
      .addCase(showPartnerByUserId.fulfilled, (state, action) => {
        state.status = "idle";
      });
  },
});

export default partnersSlice.reducer;
